import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="#000"><path d="M6 20V4l12 8.229L6 20zM18 5h1v14h-1z" /></g></svg>;